/**
 * Table (snake_case) → permission ENTITY (singular grid name), mirroring the
 * backend TABLE_TO_ENTITY (src/middleware/auth.js). The schema-driven generic
 * list/detail pages use this to gate their "+ New" / "Edit" controls on the SAME
 * entity the server authorizes, so a view-only role (training) / agent doesn't
 * see a create/edit control whose write the server rejects.
 *
 * Returns undefined for an unmapped table — the caller then leaves the control
 * UNGATED (backward compatible; no false-hide for a table we haven't mapped).
 *
 * `users` + `audit_logs` are intentionally omitted: those generic routes are
 * RequireSuperAdmin + disableCreate/disableEdit, so there is no control to gate.
 *
 * Every entry below is a table that EXISTS in `src/db/schema.sql` and carries a
 * row in the backend map. Do not prune this list by keyword — an over-eager
 * sweep once removed five live mappings (contacts, documents, invoices,
 * invoice_items, information_requests) and silently ungated their controls,
 * which reads as "works" until the server rejects the write.
 */
const TABLE_TO_ENTITY: Record<string, string> = {
  clients: 'client',
  invoices: 'invoice', invoice_items: 'invoice_item', invoice_terms: 'invoice_term',
  contacts: 'contact', documents: 'document',
  information_requests: 'information_request', notes: 'note', events: 'event',
  import_batches: 'import_batch', notifications: 'notification',
  parent_clients: 'parent_client', consultant_deals: 'consultant_deal',
};

export function tableToEntity(table: string): string | undefined {
  return TABLE_TO_ENTITY[table];
}
